import React, { useEffect, useState } from 'react'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Box } from '@mui/material'
import { CustomTabProps } from '../../types';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

interface TabContainerProps {
    tabs: CustomTabProps[],
    additionalOption?: React.ReactNode
}

export default function TabContainer({ tabs, additionalOption }: TabContainerProps) {
    const [value, setValue] = useState(0)

    const handleChange = (_: React.SyntheticEvent, newValue: number) => {
        setValue(newValue)
    }
    useEffect(() => {
        setValue(0)
    }, [tabs])
    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    {tabs.map((tab, index) => <Tab key={tab.label} label={tab.label} {...a11yProps(index)} />)}
                    {additionalOption}
                </Tabs>
            </Box>
            {tabs.map((tab, index) => <TabPanel key={tab.label} value={value} index={index}>
                {tab.panel}
            </TabPanel>)}
        </Box>
    )
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
